import { Layout } from "components/common"
import { Fragment, useEffect, useRef, useState } from "react"
import { api } from "apiServer"
import Image from "next/legacy/image"
import { Rank, Video, Match } from "components/League"
// const Match = dynamic(() => import("components/League/Match"), {
//   ssr: false
// })
let calling = false
let isChange = false
function Component({ id, video, detailLeague }) {
  const [loading, setLoading] = useState(false)
  const [videos, setVideos] = useState(video)
  const __param = useRef({
    league_id: id,
    page_num: 1,
    page_size: 24
  })
  const maxCount = useRef(50)
  const [srcImage, setSrcImage] = useState(
    "https://stvinadev.vtvcab.vn/origin/e8739074-b44c-4276-9e75-45917daa5d8a.png"
  )
  const [tab, setTab] = useState("video")
  const [tabVideo, setTabVideo] = useState("all")
  const [deVice, setDeVice] = useState("desktop")

  useEffect(() => {
    function onScroll() {
      if (window.scrollY + window.innerHeight > (document.body.scrollHeight * 6) / 7) {
        if (!calling) {
          setLoading(true)
        }
      }
    }
    window.addEventListener("scroll", onScroll)
    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])
  async function fetch() {
    if (isChange) {
      __param.current.page_num = 1
    } else {
      __param.current.page_num = __param.current.page_num + 1
    }

    try {
      const { data, count } = await api.getVideoOfLuague(null, __param.current)
      maxCount.current = count
      if (isChange) {
        setVideos(data)
      } else {
        setVideos([...videos, ...data])
      }
    } catch (error) {
      console.log(error.response)
    } finally {
      setLoading(false)
      calling = false
      isChange = false
    }
  }

  function onChangeTabVideo(value) {
    if (value === "all") {
      __param.current = {
        league_id: id,
        page_num: 1,
        page_size: 24
      }
    }
    if (value === "highlight") {
      __param.current = {
        league_id: id,
        page_num: 1,
        page_size: 24,
        is_fullmatch: false
      }
    }
    if (value === "fullmatch") {
      __param.current = {
        league_id: id,
        page_num: 1,
        page_size: 24,
        is_fullmatch: true
      }
    }
    setTabVideo(value)
    isChange = true
    fetch()
  }

  useEffect(() => {
    if (window.innerWidth < 768) {
      setDeVice("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 980) {
      setDeVice("ipad")
    } else {
      setDeVice("desktop")
    }
  }, [])

  useEffect(() => {
    if (loading && maxCount.current > videos?.length) fetch()
  }, [loading])

  const { logo, backgroud_color, name } = detailLeague
  const borderBottom = { borderBottom: "solid 4px", borderColor: "rgb(0, 14, 42)" }

  return (
    <>
      <section>
        <div className="">
          {deVice === "desktop" ? (
            <div className="relative wapper__play">
              <div className="fix_img z-0">
                <Image
                  src={srcImage}
                  width={6000}
                  height={1000}
                  alt={"image"}
                  onError={() =>
                    setSrcImage("https://stvinadev.vtvcab.vn/origin/e8739074-b44c-4276-9e75-45917daa5d8a.png")
                  }
                  // style={{ mixBlendMode: "hard-light" }}
                  className="opacity-20 z-30"
                />
              </div>
              <div
                className="absolute top-[0px] w-full h-[100%] z-10"
                style={{ backgroundColor: backgroud_color }}
              ></div>
              <div className="absolute top-[0px] w-full flex justify-center items-center h-[100%] z-30">
                <div className=" flex flex-col items-center">
                  <Image src={logo} alt={"logo"} width={160} height={160} objectFit="contain" />
                  <div className="text-center font-bold text-xl text-dark-100">{name}</div>
                </div>
              </div>
              <div className="absolute bottom-0 w-full shadow bg-slide-bander z-30">
                <div className=" flex text-dark-100 max-w-screen-xl mx-auto px-12 2xl:px-0">
                  <button
                    className="mr-2 py-2"
                    onClick={() => {
                      setTab("video")
                    }}
                    style={tab === "video" ? { borderBottom: "#52B5F9 solid 4px" } : borderBottom}
                  >
                    Video
                  </button>

                  <button
                    className="mr-2 ml-8 py-2"
                    onClick={() => {
                      setTab("rank")
                    }}
                    style={tab === "rank" ? { borderBottom: "#52B5F9 solid 4px" } : borderBottom}
                  >
                    Bảng xếp hạng
                  </button>
                  <button
                    className="mr-2 ml-8 py-2"
                    onClick={() => {
                      setTab("match")
                    }}
                    style={tab === "match" ? { borderBottom: "#52B5F9 solid 4px" } : borderBottom}
                  >
                    Lịch thi đấu
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="relative wapper__play">
              <div className="fix_img z-0">
                <Image
                  src={srcImage}
                  width={6000}
                  height={2000}
                  alt={"image"}
                  onError={() =>
                    setSrcImage("https://stvinadev.vtvcab.vn/origin/e8739074-b44c-4276-9e75-45917daa5d8a.png")
                  }
                  // style={{ mixBlendMode: "hard-light" }}
                  className="opacity-20 z-30"
                />
              </div>
              <div
                className="absolute top-[0px] w-full h-[100%] z-10"
                style={{ backgroundColor: backgroud_color }}
              ></div>
              <div className="absolute top-[0px] w-full flex justify-center mt-3 h-[100%] z-30">
                <div className=" flex flex-col items-center">
                  <Image src={logo} alt={"logo"} width={60} height={60} objectFit="contain" />
                  <div className="text-center font-bold text-sm text-dark-100">{name}</div>
                </div>
              </div>
              <div className="absolute bottom-0 w-full shadow bg-slide-bander z-30 text-sm">
                <div className=" flex text-dark-100 max-w-screen-xl mx-auto justify-center">
                  <button
                    className="mr-2 py-2"
                    onClick={() => {
                      setTab("video")
                    }}
                    style={tab === "video" ? { borderBottom: "#52B5F9 solid 4px" } : borderBottom}
                  >
                    Video
                  </button>

                  <button
                    className="mr-2 ml-8 py-2"
                    onClick={() => {
                      setTab("rank")
                    }}
                    style={tab === "rank" ? { borderBottom: "#52B5F9 solid 4px" } : borderBottom}
                  >
                    Bảng xếp hạng
                  </button>
                  <button
                    className="mr-2 ml-8 py-2"
                    onClick={() => {
                      setTab("match")
                    }}
                    style={tab === "match" ? { borderBottom: "#52B5F9 solid 4px" } : borderBottom}
                  >
                    Lịch thi đấu
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="py-2 md:py-12 max-w-screen-xl mx-auto px-4 md:px-12 2xl:px-0 text-dark-100 ">
            {tab === "video" && (
              <Video
                videos={videos}
                tabVideo={tabVideo}
                setTabVideo={setTabVideo}
                onChangeTabVideo={onChangeTabVideo}
              />
            )}
            {tab === "rank" && <Rank id={id} />}
            {tab === "match" && <Match id={id} />}
          </div>
        </div>
      </section>
    </>
  )
}
export default Component
Component.Layout = Layout

export async function getServerSideProps({ req, query, res }) {
  const { cookies } = req
  const { id } = query
  let video = {}
  let detailLeague = {}
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  try {
    const { data, success } = await api.getDedailLeague(cookies?.accessToken, id, {
      page_num: 1,
      page_size: 24
    })
    if (success) detailLeague = data
  } catch (error) {
    console.log(error?.response?.data || error)
  }
  try {
    const { data, success } = await api.getVideoOfLuague(cookies?.accessToken, {
      league_id: id,
      page_num: 1,
      page_size: 24
    })
    if (video) video = data
  } catch (error) {
    console.log(error?.response?.data || error)
  }
  return { props: { id, video, detailLeague } }
}
